import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { TdspBaseEntityService } from "../rest-common.service";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class TdspPixelService extends TdspBaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  get resource_url(): string {
    return `${this.activeBaseUrl}/pixel/`;
  }

  getEventTypes(params = {}) {
    let url = this.buildUrl(`${this.resource_url}event-types/`, "", params);
    return this.get(url);
  }

  getPixelTag(params: any) {
    let url = this.buildUrl(`${this.resource_url}tag/`, "", params);
    return this.get(url);
  }

  getBulkPixelTags(params: any) {
    let url = this.buildUrl(`${this.resource_url}tag/`, "", params);
    return this.get(url);
  }
}
